import { NgModule } from "@angular/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { SharedCoreModule } from "app/helpers/shared-core.module";
import { ProfileModalComponent } from "./profile-modal.component";

@NgModule({
  declarations: [ProfileModalComponent],
  imports: [SharedCoreModule, MatSnackBarModule],
  exports: [ProfileModalComponent],
})
export class ProfileModalModule {}
